var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("AccountManagement.work.reviewTitle"),
        visible: _vm.visible,
        "custom-class": "timesheet-review-dialog",
        width: "94%",
        top: "5vh",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        closed: _vm.cancelLoad,
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "timesheet-review",
        },
        [
          _c(
            "div",
            { staticClass: "review-toolbar" },
            [
              _c("strong", [
                _vm._v(
                  _vm._s(_vm.workDate ? _vm.workDate.substring(0, 10) : "")
                ),
              ]),
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: _vm.$t("AccountManagement.work.reviewAll"),
                    clearable: "",
                    filterable: "",
                  },
                  model: {
                    value: _vm.department,
                    callback: function ($$v) {
                      _vm.department = $$v
                    },
                    expression: "department",
                  },
                },
                [
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("AccountManagement.work.reviewAll"),
                      value: "",
                    },
                  }),
                  _vm._l(_vm.departments, function (item) {
                    return _c("el-option", {
                      key: String(item.value),
                      attrs: { label: item.label, value: String(item.value) },
                    })
                  }),
                ],
                2
              ),
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.load },
                  model: {
                    value: _vm.sourceType,
                    callback: function ($$v) {
                      _vm.sourceType = $$v
                    },
                    expression: "sourceType",
                  },
                },
                [
                  _c("el-radio-button", { attrs: { label: "actual" } }, [
                    _vm._v(_vm._s(_vm.$t("AccountManagement.work.actual"))),
                  ]),
                  _c("el-radio-button", { attrs: { label: "overtime" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("AccountManagement.work.reviewOvertime"))
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-refresh", disabled: _vm.loading },
                  on: { click: _vm.refresh },
                },
                [_vm._v(_vm._s(_vm.$t("AccountManagement.work.reviewRefresh")))]
              ),
            ],
            1
          ),
          _vm.error
            ? _c("el-alert", {
                attrs: {
                  title: _vm.error,
                  type: "error",
                  closable: false,
                  "show-icon": "",
                },
              })
            : _vm._e(),
          _vm.invalidCount
            ? _c("el-alert", {
                attrs: {
                  title: _vm.$t("AccountManagement.work.reviewInvalid", {
                    count: _vm.invalidCount,
                  }),
                  type: "warning",
                  closable: false,
                  "show-icon": "",
                },
              })
            : _vm._e(),
          _vm.conflictCount
            ? _c("el-alert", {
                attrs: {
                  title: _vm.$t("AccountManagement.work.reviewConflict", {
                    count: _vm.conflictCount,
                  }),
                  type: "warning",
                  closable: false,
                  "show-icon": "",
                },
              })
            : _vm._e(),
          _vm.gapCount
            ? _c("el-alert", {
                attrs: {
                  title: _vm.$t("AccountManagement.work.reviewGapCount", {
                    count: _vm.gapCount,
                  }),
                  type: "warning",
                  closable: false,
                  "show-icon": "",
                },
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "review-legend" },
            [
              _vm.sourceType === "overtime" && _vm.rows.length
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "text", icon: "el-icon-position" },
                      on: { click: _vm.scrollToRecords },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("AccountManagement.work.reviewLocate"))
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._l(_vm.legend, function (item) {
                return _c("span", { key: item }, [
                  _c("i", { style: { background: _vm.color(item) } }),
                  _vm._v(_vm._s(_vm.label(item))),
                ])
              }),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t("AccountManagement.work.reviewPeople", {
                      count: _vm.rows.length,
                    })
                  )
                ),
              ]),
              _c("span", { staticClass: "review-overlap-key" }, [
                _c("i"),
                _vm._v(_vm._s(_vm.$t("AccountManagement.work.reviewOverlap"))),
              ]),
              _c("span", { staticClass: "review-gap-key" }, [
                _c("i"),
                _vm._v(_vm._s(_vm.$t("AccountManagement.work.reviewGap"))),
              ]),
            ],
            2
          ),
          _vm.rows.length
            ? _c(
                "div",
                {
                  ref: "chart",
                  staticClass: "review-scroll",
                  attrs: {
                    role: "region",
                    "aria-label": _vm.$t("AccountManagement.work.reviewTitle"),
                    tabindex: "0",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "review-chart",
                      style: {
                        minWidth: 180 + _vm.ticks.length * 64 + "px",
                        "--review-tick-count": _vm.ticks.length,
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "review-header" },
                        [
                          _c("div", { staticClass: "review-name" }, [
                            _vm._v(
                              _vm._s(_vm.$t("AccountManagement.staff.name"))
                            ),
                          ]),
                          _vm._l(_vm.ticks, function (tick) {
                            return _c(
                              "div",
                              { key: tick, staticClass: "review-tick" },
                              [_vm._v(_vm._s(_vm.formatMinutes(tick)))]
                            )
                          }),
                        ],
                        2
                      ),
                      _vm._l(_vm.rows, function (person) {
                        return _c(
                          "div",
                          {
                            key: person.key,
                            staticClass: "review-person",
                            style: { minHeight: person.lanes * 42 + 16 + "px" },
                          },
                          [
                            _c("div", { staticClass: "review-name" }, [
                              _c("strong", [_vm._v(_vm._s(person.name))]),
                              person.conflicts.length
                                ? _c(
                                    "span",
                                    { staticClass: "review-warning" },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-warning",
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "AccountManagement.work.reviewOverlap"
                                            )
                                          )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              person.gaps.length
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "review-warning review-gap-warning",
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-warning-outline",
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "AccountManagement.work.reviewGap"
                                            )
                                          )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                            _c(
                              "div",
                              { staticClass: "review-track" },
                              [
                                _vm._l(person.gaps, function (gap, index) {
                                  return _c(
                                    "el-tooltip",
                                    {
                                      key: "gap:" + index,
                                      attrs: {
                                        placement: "top",
                                        content:
                                          person.name +
                                          " · " +
                                          _vm.$t(
                                            "AccountManagement.work.reviewGap"
                                          ) +
                                          " · " +
                                          _vm.formatMinutes(gap.start) +
                                          " – " +
                                          _vm.formatMinutes(gap.end),
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "review-gap",
                                          style: _vm.gapStyle(gap),
                                          attrs: { tabindex: "0" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "AccountManagement.work.reviewGap"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                                _vm._l(person.records, function (record) {
                                  return _c(
                                    "el-tooltip",
                                    {
                                      key: record.key,
                                      attrs: {
                                        placement: "top",
                                        "open-delay": 150,
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "content" },
                                          slot: "content",
                                        },
                                        [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(person.name) +
                                                " · " +
                                                _vm._s(
                                                  _vm.formatMinutes(
                                                    record.start
                                                  )
                                                ) +
                                                " – " +
                                                _vm._s(
                                                  _vm.formatMinutes(record.end)
                                                )
                                            ),
                                          ]),
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(_vm.recordLabel(record))
                                            ),
                                          ]),
                                          record.overlap
                                            ? _c("div", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "AccountManagement.work.reviewOverlap"
                                                    )
                                                  )
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "review-bar",
                                          class: {
                                            "has-overlap": record.overlap,
                                          },
                                          style: _vm.barStyle(record),
                                          attrs: { tabindex: "0" },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              style: {
                                                background: _vm.color(
                                                  record.department
                                                ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.recordLabel(record))
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                              ],
                              2
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ]
              )
            : !_vm.loading && !_vm.error
            ? _c("div", { staticClass: "review-empty" }, [
                _vm._v(_vm._s(_vm.$t("AccountManagement.work.reviewEmpty"))),
              ])
            : _vm._e(),
          _vm.conflictCount || _vm.gapCount
            ? _c(
                "div",
                { staticClass: "review-conflicts" },
                [
                  _vm._l(_vm.rows, function (person) {
                    return [
                      _vm._l(person.conflicts, function (conflict, index) {
                        return _c("div", { key: person.key + ":" + index }, [
                          _c("i", { staticClass: "el-icon-warning" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("AccountManagement.work.reviewOverlap")
                              ) +
                              " · " +
                              _vm._s(person.name) +
                              " · " +
                              _vm._s(_vm.formatMinutes(conflict.start)) +
                              " – " +
                              _vm._s(_vm.formatMinutes(conflict.end))
                          ),
                          _vm.conflictLabel(conflict)
                            ? _c("span", [
                                _vm._v(
                                  " · " + _vm._s(_vm.conflictLabel(conflict))
                                ),
                              ])
                            : _vm._e(),
                        ])
                      }),
                      _vm._l(person.gaps, function (gap, index) {
                        return _c(
                          "div",
                          {
                            key: person.key + ":gap:" + index,
                            staticClass: "review-gap-warning",
                          },
                          [
                            _c("i", { staticClass: "el-icon-warning-outline" }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("AccountManagement.work.reviewGap")
                                ) +
                                " · " +
                                _vm._s(person.name) +
                                " · " +
                                _vm._s(_vm.formatMinutes(gap.start)) +
                                " – " +
                                _vm._s(_vm.formatMinutes(gap.end)) +
                                " "
                            ),
                          ]
                        )
                      }),
                    ]
                  }),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("AccountManagement.work.close")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }